/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type workarea_assignBeds_MutationVariables = {|
  exchangeNames: $ReadOnlyArray<string>
|};
export type workarea_assignBeds_MutationResponse = {|
  +workAreaMutation: ?{|
    +assignBeds: ?$ReadOnlyArray<?{|
      +id: string
    |}>
  |}
|};
export type workarea_assignBeds_Mutation = {|
  variables: workarea_assignBeds_MutationVariables,
  response: workarea_assignBeds_MutationResponse,
|};
*/


/*
mutation workarea_assignBeds_Mutation(
  $exchangeNames: [String!]!
) {
  workAreaMutation {
    assignBeds(exchangeNames: $exchangeNames) {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "exchangeNames"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "WorkAreaMutation",
    "kind": "LinkedField",
    "name": "workAreaMutation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "exchangeNames",
            "variableName": "exchangeNames"
          }
        ],
        "concreteType": "Facility",
        "kind": "LinkedField",
        "name": "assignBeds",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "workarea_assignBeds_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "workarea_assignBeds_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e98eb0abdca8606577d35d69eb372c05",
    "id": null,
    "metadata": {},
    "name": "workarea_assignBeds_Mutation",
    "operationKind": "mutation",
    "text": "mutation workarea_assignBeds_Mutation(\n  $exchangeNames: [String!]!\n) {\n  workAreaMutation {\n    assignBeds(exchangeNames: $exchangeNames) {\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '963d03921383bb8073fbc298d69af3c3';

module.exports = node;
